export const APP_ID = process.env.NEXT_PUBLIC_APP_ID || '984582';
